import { connectHook } from '../../connect-hook';
import { Monaco } from './monaco';
import { useMonaco } from './monaco-hook';

export default connectHook(Monaco, useMonaco);
